import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { changeWidgetJSProp, updateWidgetJSPropField } from '../../actions';

export * from './autoComplete';

export const labelTextReplace = (str = '') =>
    str.replace(/(^[a-z]{1})|([A-Z])/g, (_, firstLater, upparCaseLater) => {
        if (firstLater) {
            return firstLater.toUpperCase();
        } else {
            return ' ' + upparCaseLater;
        }
    });

export const addRefComponent = () =>
    withHandlers(() => {
        let refElement = null;

        return {
            getRef: () => () => refElement,
            setRef: () => ref => {
                refElement = ref;
            },
        };
    });

export const withSubscribeEvent = (eventName = '') =>
    compose(
        withStateHandlers({ id: null }, { enterEditMode: () => id => ({ id: id }) }),
        connect(
            ({ editor = {} }, { id }) => ({
                params: (editor.widgetProps && editor.widgetProps[id]) || {},
                widgetProps: editor.widgetProps,
            }),
            { changeWidgetJSProp, updateWidgetJSPropField },
        ),
        lifecycle({
            onManipulation(event = { detail: {} }) {
                const { detail = {} } = event;

                switch (detail.type) {
                    case 'ACTIVATE': {
                        if (this.props.id) {
                            this.props.updateWidgetJSPropField(this.props.id, { active: false });
                        }

                        this.props.updateWidgetJSPropField(detail.id, {
                            ...(detail.values || {}),
                            active: true,
                        });
                        this.props.enterEditMode(detail.id);

                        break;
                    }
                    case 'DEACTIVATE': {
                        if (this.props.id) {
                            this.props.updateWidgetJSPropField(this.props.id, { active: false });
                            this.props.enterEditMode(null);
                        }

                        if (
                            this.props.widgetProps &&
                            this.props.widgetProps[detail.id] &&
                            this.props.widgetProps[detail.id].active
                        ) {
                            this.props.updateWidgetJSPropField(detail.id, { active: false });
                        }

                        break;
                    }
                }
            },

            componentDidMount() {
                this._listenter = this.onManipulation.bind(this);
                window.addEventListener(eventName, this._listenter);
            },
            // componentWillReceiveProps({ id }) {
            //     console.log(id, this.props.id);
            //     if (id && this.props.id !== id) {
            //         this.props.updateWidgetJSPropField(this.props.id, { active: false });
            //     }
            // },
            componentWillUnmount() {
                if (this.props.id) {
                    this.props.updateWidgetJSPropField(this.props.id, { active: false });
                }
                window.removeEventListener(eventName, this._listenter);
            },
        }),
    );



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/helpers/index.js
 **/